import type { OnboardingCountryCode, OnboardingCurrencyCode, OnboardingDraft } from '../types/onboarding';
import { ONBOARDING_STEP } from '../types/onboarding';
import { getCurrencyForCountry, getIncomeMarks } from './countryInvestmentCatalog';

const VALID_COUNTRIES: OnboardingCountryCode[] = ['US', 'CA', 'IN', 'GB', 'OTHER'];
const VALID_CURRENCIES: OnboardingCurrencyCode[] = ['USD', 'CAD', 'INR', 'GBP'];

export function createEmptyOnboardingDraft(
  countryCode: OnboardingCountryCode = 'US',
): OnboardingDraft {
  const marks = getIncomeMarks(countryCode);
  return {
    countryCode,
    currencyCode: marks.currencyCode,
    monthlyIncomeAfterTax: marks.mid,
    assets: [],
    liabilities: [],
    expectedSpendByCategory: [],
    dismissedModal: true,
    completedIntro: false,
    step: ONBOARDING_STEP.INTRO,
  };
}

export function normalizeOnboardingDraft(partial: Partial<OnboardingDraft>): OnboardingDraft {
  const countryCode = VALID_COUNTRIES.includes(partial.countryCode as OnboardingCountryCode)
    ? (partial.countryCode as OnboardingCountryCode)
    : 'US';
  const base = createEmptyOnboardingDraft(countryCode);
  const currencyCode = VALID_CURRENCIES.includes(partial.currencyCode as OnboardingCurrencyCode)
    ? (partial.currencyCode as OnboardingCurrencyCode)
    : getCurrencyForCountry(countryCode);

  return {
    ...base,
    ...partial,
    countryCode,
    currencyCode,
    monthlyIncomeAfterTax:
      typeof partial.monthlyIncomeAfterTax === 'number' && Number.isFinite(partial.monthlyIncomeAfterTax)
        ? Math.max(0, partial.monthlyIncomeAfterTax)
        : base.monthlyIncomeAfterTax,
    assets: Array.isArray(partial.assets) ? partial.assets : base.assets,
    liabilities: Array.isArray(partial.liabilities) ? partial.liabilities : base.liabilities,
    expectedSpendByCategory: Array.isArray(partial.expectedSpendByCategory)
      ? partial.expectedSpendByCategory
      : base.expectedSpendByCategory,
    dismissedModal:
      typeof partial.dismissedModal === 'boolean' ? partial.dismissedModal : base.dismissedModal,
    completedIntro: Boolean(partial.completedIntro),
    step:
      typeof partial.step === 'number' && Number.isFinite(partial.step)
        ? Math.max(ONBOARDING_STEP.INTRO, Math.min(ONBOARDING_STEP.UPLOAD, Math.floor(partial.step)))
        : base.step,
  };
}
